var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},_vm._l((_vm.myOG),function(value,key,index){return _c('meta',{key:index,attrs:{"tag":"meta","property":key,"content":value}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }